import React from 'react';
import { ExternalLinkIcon, FileTextIcon, CalendarIcon } from 'lucide-react';
interface AlgaResponseWidgetProps {
  isDarkMode?: boolean;
}
const AlgaResponseWidget: React.FC<AlgaResponseWidgetProps> = ({
  isDarkMode = false
}) => {
  return <div className="animate-fadeIn mt-4 ml-12" data-id="element-1418">
      <div className={`rounded-lg overflow-hidden ${isDarkMode ? 'bg-[#171717] border border-[#171717]' : 'bg-white border border-gray-200'}`} data-id="element-1419">
        <div className={`p-3 ${isDarkMode ? 'border-b border-[#171717]' : 'border-b border-gray-200'}`} data-id="element-1420">
          <h3 className={`font-medium ${isDarkMode ? 'text-white' : 'text-[#919191]'}`} data-id="element-1421">
            Informazioni sul corso di Innovazione Sostenibile
          </h3>
        </div>
        <div className="p-4" data-id="element-1422">
          <div className={`mb-4 ${isDarkMode ? 'text-white' : 'text-[#919191]'}`} data-id="element-1423">
            <p className="text-sm mb-2" data-id="element-1424">
              Il corso di Innovazione Sostenibile copre i seguenti argomenti
              principali:
            </p>
            <ul className="list-disc pl-5 text-sm space-y-1" data-id="element-1425">
              <li data-id="element-1426">Modelli di business sostenibili e circolari</li>
              <li data-id="element-1427">Strategie di implementazione ESG</li>
              <li data-id="element-1428">Tecnologie per la sostenibilità</li>
              <li data-id="element-1429">Reporting e misurazione dell'impatto</li>
            </ul>
          </div>
          <div className={`flex items-center p-3 rounded-lg ${isDarkMode ? 'bg-[#212121]' : 'bg-gray-50'} mb-3`} data-id="element-1430">
            <div className="mr-3" data-id="element-1431">
              <FileTextIcon size={20} className={isDarkMode ? 'text-white' : 'text-[#919191]'} data-id="element-1432" />
            </div>
            <div data-id="element-1433">
              <div className={`font-medium text-sm ${isDarkMode ? 'text-white' : 'text-[#919191]'}`} data-id="element-1434">
                Materiale di studio - Modulo 3
              </div>
              <div className={`text-xs ${isDarkMode ? 'text-white/70' : 'text-[#919191]'}`} data-id="element-1435">
                PDF • 28 pagine
              </div>
            </div>
            <button className="ml-auto px-2 py-1 rounded text-xs bg-custom-green text-white hover:bg-custom-green/90" data-id="element-1436">
              Apri
            </button>
          </div>
          <div className={`flex items-center p-3 rounded-lg ${isDarkMode ? 'bg-[#212121]' : 'bg-gray-50'}`} data-id="element-1437">
            <div className="mr-3" data-id="element-1438">
              <CalendarIcon size={20} className={isDarkMode ? 'text-white' : 'text-[#919191]'} data-id="element-1439" />
            </div>
            <div data-id="element-1440">
              <div className={`font-medium text-sm ${isDarkMode ? 'text-white' : 'text-[#919191]'}`} data-id="element-1441">
                Prossima lezione: Strategie ESG
              </div>
              <div className={`text-xs ${isDarkMode ? 'text-white/70' : 'text-[#919191]'}`} data-id="element-1442">
                Domani • 14:00 - 15:30
              </div>
            </div>
            <button className="ml-auto px-2 py-1 rounded text-xs bg-custom-green text-white hover:bg-custom-green/90" data-id="element-1443">
              Calendario
            </button>
          </div>
        </div>
        <div className={`px-4 py-3 ${isDarkMode ? 'border-t border-[#171717] bg-[#171717]' : 'border-t border-gray-200 bg-gray-50'}`} data-id="element-1444">
          <button className={`w-full text-sm flex items-center justify-center ${isDarkMode ? 'text-white hover:text-white/80' : 'text-[#919191] hover:text-[#919191]/80'}`} data-id="element-1445">
            <ExternalLinkIcon size={16} className="mr-2" data-id="element-1446" />
            Vai al corso completo
          </button>
        </div>
      </div>
    </div>;
};
export default AlgaResponseWidget;